import React, { type PropsWithChildren } from 'react';
import { CopyPasteContextProvider } from '@atlassian/jira-issue-field-copy-paste/src/ui/index.tsx';
import {
	useIsInlineEditingEnabled,
	useIsInlineEditingExtendedFieldSupportEnabled,
} from '../../controllers/features/selectors.tsx';

export const CopyPasteContainer = ({ children }: PropsWithChildren<{}>) => {
	const isInlineEditingEnabled = useIsInlineEditingEnabled();
	const isInlineEditingExtendedFieldSupportEnabled =
		useIsInlineEditingExtendedFieldSupportEnabled();
	return isInlineEditingEnabled && isInlineEditingExtendedFieldSupportEnabled ? (
		<CopyPasteContextProvider>{children}</CopyPasteContextProvider>
	) : (
		children
	);
};
